import { render, staticRenderFns } from "./residentAdd.vue?vue&type=template&id=fd274524&scoped=true&"
import script from "./residentAdd.vue?vue&type=script&lang=js&"
export * from "./residentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd274524",
  null
  
)

export default component.exports